import { Button, Column, ComposedModal, Grid, ModalBody, ModalFooter, ModalHeader, Row } from '@metrika/ui-kit/carbon';
import React from 'react';

interface Props {
   onLogin: () => void;
   onCancel: () => void;
   title?: string;
   description?: string;
}

export const LoginRequestModal = ({
   onLogin,
   onCancel,
   title = 'Sign in',
   description = 'You need to sign in for view this content',
}: Props) => {
   return (
      <ComposedModal size="sm" preventCloseOnClickOutside={true} open onClose={onCancel}>
         <ModalHeader>
            <h3>{title}</h3>
         </ModalHeader>
         <ModalBody>
            <Grid condensed fullWidth>
               <Row>
                  <Column lg={16}>
                     <p>{description}</p>
                  </Column>
               </Row>
            </Grid>
         </ModalBody>
         <ModalFooter>
            <Button kind="secondary" onClick={onCancel}>
               Cancel
            </Button>
            <Button kind="primary" onClick={onLogin}>
               Sign-In
            </Button>
         </ModalFooter>
      </ComposedModal>
   );
};
